import { render } from "./PrivacyPolicyLink.vue?vue&type=template&id=0f8d7f73"
import script from "./PrivacyPolicyLink.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyLink.vue?vue&type=script&lang=js"

import "./PrivacyPolicyLink.vue?vue&type=style&index=0&id=0f8d7f73&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__